import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';

import { NcCard, NcContainerPropsT } from './NcCard';

import '@consumer-bootstrap/netcredit.scss';

export type NcCardPanelT = React.FC<NcContainerPropsT>;

/**
 * NcCardPanel component
 *
 * This is for the rounded grey panels inside the cards used across the dashboard.
 */
export const NcCardPanel: NcCardPanelT = ({ className, ...props }) => (
  <NcCard
    className={mergeClassNameStrings(className, 'panel')}
    noBoxShadow
    {...props}
  />
);
